import { Component } from '@angular/core';
import { MaritalStatusService } from '../marital-status.service';
import { MaritalStatus } from '../marital-status';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../shared/notification.service';

@Component({
  selector: 'app-marital-status-edit',
  templateUrl: 'edit.component.html',
})
export class MaritalStatusEditComponent {
  /**
   * Details of the maritalStatus being edited.
   */
  public maritalStatus: MaritalStatus;

  /**
   * Are we currently performing a loading action?
   *
   * @type {boolean}
   */
  public isLoading: boolean = false;

  /**
   * Load up all our required services and subscribe to every observable we need.
   *
   * @param {MaritalStatusService} maritalStatusService
   * @param {NotificationService} notificationService
   * @param {Router} router
   * @param {ActivatedRoute} route
   */
  constructor(
    private maritalStatusService: MaritalStatusService,
    private notificationService: NotificationService,
    private router: Router,
    private route: ActivatedRoute,
  ) {
    this.maritalStatusService.loading.subscribe(
      result => (this.isLoading = result),
    );
    this.route.params.subscribe(params => this.loadMaritalStatus(params.id));
  }

  /**
   * Perform the edit action which send the edited maritalStatus to the backend.
   */
  public edit() {
    const editMaritalStatus = this.maritalStatusService
      .updateMaritalStatus(this.maritalStatus.id, this.maritalStatus)
      .subscribe(
        (result: MaritalStatus) => {
          this.notificationService.success(
            `Marital Status Updated`,
            `The marital Status ${
              result.name
            } been updated with the specified changes.`,
            5,
          );
          this.maritalStatus = new MaritalStatus();
          editMaritalStatus.unsubscribe();
          this.router.navigate(['/marital-statuses']);
        },
        err => {
          this.notificationService.error(
            `Marital Status Not Found`,
            err.error.message,
            10,
          );
          this.router.navigate(['/marital-statuses']);
        },
      );
  }

  /**
   * Loads the requested maritalStatus so we can display it and let the user edit the fields.
   *
   * @param {string} id
   */
  private loadMaritalStatus(id: string) {
    this.maritalStatusService.findMaritalStatus(id).subscribe(
      result => {
        this.maritalStatus = result;
      },
      err => {
        this.notificationService.error(
          `Marital Status Not Found`,
          err.error.message,
          10,
        );
        this.router.navigate(['/marital-statuses']);
      },
    );
  }
}
